<script lang="ts" setup>
import { isInstagramBrowserAgent } from '@/utils';
import { useAllowCookies } from '~/composables/useAllowCookies';
import { onMounted, ref } from 'vue';

import IconMaterialSymbolsLightDone from '~icons/material-symbols/done';

import TextLink from '../ui/text-link/TextLink.vue';

const { acceptCookies } = useAllowCookies();
const isInstagramBrowser = ref(false);
const bannerElement = ref<HTMLElement | null>(null);

onMounted(() => {
	isInstagramBrowser.value = isInstagramBrowserAgent();
});

function handleAcceptCookies() {
	acceptCookies();

	if (isInstagramBrowser.value) {
		const banner = document.querySelector('[data-cookies-banner]');

		if (!banner) return;

		bannerElement.value = banner as HTMLElement;

		const timeout = setTimeout(() => {
			const bannerStillVisible = document.body.contains(bannerElement.value);
			if (bannerStillVisible) {
				window.location.reload();
			} else {
				clearTimeout(timeout);
			}
		}, 500);
	}
}
</script>
<template>
	<div
		data-cookies-banner
		class="flex flex-col justify-between gap-3 border-t border-primary-light-3 bg-primary-light-4 px-5 pb-6 pt-4 md:flex-row md:border md:border-b-0 md:py-5! md:px-12"
	>
		<div class="flex items-center justify-center">
			<p class="text-xs leading-[21px] text-white md:text-sm">
				Usamos cookies para oferecer uma experiência melhor para você. Ao
				prosseguir, você está ciente da nossa
				<NuxtLink
					to="/politica-de-privacidade"
					target="_blank"
					rel="noopener noreferrer"
				>
					<TextLink as="p" variant="dark"> Política de Privacidade </TextLink>
				</NuxtLink>
			</p>
		</div>
		<Button
			variant="primary-dark"
			class="h-10 w-full md:h-9 md:w-fit"
			@click="handleAcceptCookies"
		>
			<IconMaterialSymbolsLightDone class="size-4 text-primary" />
			<span class="text-sm font-medium md:text-xs">Ok, entendi </span>
		</Button>
	</div>
</template>
